module.exports = __webpack_public_path__ + "static/img/pot.65308ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/pot.png
// module id = vzJF
// module chunks = 53